module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("message.my_account")) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('ul', [_vm._l((_vm.menuList), function(menu_url, menu_name) {
    return [_c('li', {
      staticClass: "item-content item-link"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('router-link', {
      attrs: {
        "to": menu_url
      }
    }, [_vm._v("\n                                    " + _vm._s(menu_name) + "           \n                                ")])], 1)])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "account_footer"
  }, [_c('a', {
    staticClass: "button button-fill button-bbb",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.logoutAccount()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("message.logout")) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-f7"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f0c5fd1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/account/Index.vue
// module id = 251
// module chunks = 1